export const DI_API_TYPES = {
  TrxFilterSocketAPIService: Symbol.for('TrxFilterSocketAPIService'),
  AddressesFilterSocketAPIService: Symbol.for(
    'AddressesFilterSocketAPIService'
  ),
  AIThreadSocketAPIService: Symbol.for('AIThreadSocketAPIService'),
  AIThreadSocketAPIServiceFactory: Symbol.for(
    'AIThreadSocketAPIServiceFactory'
  ),
  AIThreadsSocketAPIService: Symbol.for('AIThreadsSocketAPIService'),
  SettingsSocketAPIService: Symbol.for('SettingsSocketAPIService'),

  ExplorerRestAPIService: Symbol.for('ExplorerRestAPIService'),
  DashboardRestAPIService: Symbol.for('DashboardRestAPIService'),
  CategoriesRestAPIService: Symbol.for('CategoriesRestAPIService'),
  LifoSocketAPIService: Symbol.for('LifoSocketAPIService'),
  EntitiesCSVRestAPIService: Symbol.for('EntitiesCSVRestAPIService'),
  GraphExportRestAPIService: Symbol.for('GraphExportRestAPIService'),
  BulkSearchExportRestAPIService: Symbol.for('BulkSearchExportRestAPIService'),
  SettingsRestAPIService: Symbol.for('SettingsRestAPIService'),
  SwapsSocketAPIService: Symbol.for('SwapsSocketAPIService'),
  ReadOnlyGraphsSocketAPIService: Symbol.for('ReadOnlyGraphsSocketAPIService'),
  AlertSocketAPIService: Symbol.for('AlertSocketAPIService'),
}
